import React, { useState, useEffect } from 'react';
import { Box, Typography, Collapse, Card, CardMedia, CardContent, Button,   Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField } from '@mui/material';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const EbrarySubjects = () => {
  const [selectedCourseId, setSelectedCourseId] = useState('');
  const user = JSON.parse(localStorage.getItem('user'));
  const userCollegeId = user?.collegeId || null;
  const [selectedCourseName, setSelectedCourseName] = useState('');
  const [selectedCourseDesc, setSelectedCourseDesc] = useState('');
  const [subjects, setSubjects] = useState([]);
  const [expanded, setExpanded] = useState(null);
  const [books, setBooks] = useState({});
  const [loadingBooks, setLoadingBooks] = useState({});
  const [userId, setUserId] = useState(null);
  const [error, setError] = useState(null);
  const [courses, setCourses] = useState([]);
  const navigate = useNavigate();
  const [bookIdsWithChapters, setBookIdsWithChapters] = useState(new Set());
  const [pdfUrl, setPdfUrl] = useState(null);

  const [openRecommendModal, setOpenRecommendModal] = useState(false);
  const [collegeEmail, setCollegeEmail] = useState('');
  const [submitStatus, setSubmitStatus] = useState('');
  const [mappedBookIds, setMappedBookIds] = useState(new Set());
  const [subjectIdsWithModules, setSubjectIdsWithModules] = useState(new Set());

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    const token = localStorage.getItem('token');

    if (user && (user.userId || user._id) && token) {
      setUserId(user.userId || user._id);
    } else {
      setError("User is not logged in.");
    }
  }, []);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (!user || !user._id) return;
  
    axios.get(`https://backend.scholarkart.in/api/users/${user._id}/enrolled-courses`)
      .then((res) => {
        const enrolled = res.data;
        setCourses(enrolled);
  
        if (enrolled.length > 0) {
          setSelectedCourseId(enrolled[0]._id);
          setSelectedCourseName(enrolled[0].courseName);
          setSelectedCourseDesc(enrolled[0].description || '');
        }
      })
      .catch((err) => console.error('Failed to fetch enrolled courses:', err));
  }, []);
  
  useEffect(() => {
    if (userCollegeId) {
      axios.get(`https://backend.scholarkart.in/api/bookcollege-map/college/${userCollegeId}`)
        .then((res) => {
          setMappedBookIds(new Set(res.data.bookIds || []));
        })
        .catch((err) => console.error("Error fetching mapped books:", err));
    }
  }, [userCollegeId]);



  useEffect(() => {
    const subjectIds = subjects.map(s => s._id);
    if (subjectIds.length === 0) return;
  
    axios.post('https://backend.scholarkart.in/api/elearning/subjects', {
      subjectIds  // ✅ should be: ['id1', 'id2', ...]
    })
    .then((res) => {
      setSubjectIdsWithModules(new Set(res.data.subjectIds.map(id => String(id))));
    })
    .catch((err) => console.error('Error fetching module subject IDs:', err));
  }, [subjects]);



  useEffect(() => {
    if (userId) {
      const token = localStorage.getItem('token');
      axios.get(`https://backend.scholarkart.in/api/student/${userId}/subjects`, {
        params: { courseId: selectedCourseId },
        headers: { Authorization: `Bearer ${token}` }
      })
        .then((response) => {
          const sortedSubjects = response.data.sort((a, b) => {
            return (parseInt(a.semisterNo) || 0) - (parseInt(b.semisterNo) || 0);
          });
          setSubjects(sortedSubjects);
        })
        .catch((error) => {
          console.error("Error fetching subjects:", error.message);
          setError("Error fetching subjects: " + error.message);
        });
    }
  }, [userId]);


  const [selectedBook, setSelectedBook] = useState(null);

  const handleExpandClick = async (subjectId) => {
    const isExpanded = expanded === subjectId ? null : subjectId;
    setExpanded(isExpanded);
  
    if (isExpanded && !books[subjectId]) {
      setLoadingBooks((prev) => ({ ...prev, [subjectId]: true }));
  
      try {
        const response = await axios.get(`https://backend.scholarkart.in/api/subjects/${subjectId}/books`);
        const bookList = response.data || [];
        setBooks((prev) => ({ ...prev, [subjectId]: bookList }));
  
        // ✅ Step: Extract all bookIds and check for chapters
        const bookIds = bookList.map(book => book._id);
        const chapterRes = await axios.post(`https://backend.scholarkart.in/api/bookchapters/exist`, {
          bookIds
        });
        const chapterSet = new Set(chapterRes.data.bookIdsWithChapters);
        setBookIdsWithChapters(prev => new Set([...prev, ...chapterSet]));
  
      } catch (error) {
        console.error("Error fetching books or chapter info:", error.message);
        setBooks((prev) => ({ ...prev, [subjectId]: [] }));
      } finally {
        setLoadingBooks((prev) => ({ ...prev, [subjectId]: false }));
      }
    }
  };
  


  const handleReadBook = (book) => {
    const user = JSON.parse(localStorage.getItem('user'));
    const token = localStorage.getItem('token');
  
    if (user && token) {
      // Save book access log but don't block UI if it fails
      axios.post('https://backend.scholarkart.in/api/bookaccesslog', {
        userId: user._id,
        collegeId: user.collegeId,
        bookId: book._id
      }, {
        headers: { Authorization: `Bearer ${token}` }
      }).then(res => {
        console.log('✅ Book access log saved:', res.data);
      }).catch((error) => {
        console.error('Error saving book access log:', error);
      });
    } else {
      console.error('User or token missing');
    }
  
    // Open the book anyway
    setPdfUrl(book.pdfURL);
  };
    

  const handleRecommendSubmit = async () => {
    if (!collegeEmail || !collegeEmail.includes('@')) {
      setSubmitStatus('Please enter a valid email.');
      return;
    }
  
    try {
      await axios.post('https://backend.scholarkart.in/api/recommendations/email', {
        userId: user?._id,
        userName: user?.username,
        studentEmail: user?.email,
        email: collegeEmail,
        bookTitle: selectedBook?.bookTitle || 'Book from Ebrary',
      });
  
      setSubmitStatus('Recommendation sent successfully!');
      setTimeout(() => {
        setOpenRecommendModal(false);
        setSubmitStatus('');
        setCollegeEmail('');
      }, 2000);
    } catch (error) {
      setSubmitStatus('Failed to send recommendation.');
      console.error(error);
    }
  };



  return (
    
    <Box sx={{ padding: 1 }}>
 
      <Typography variant="h4" sx={{ marginBottom: 1 }}>
        📘 {selectedCourseName}
      </Typography>

      {selectedCourseDesc && (
        <Typography variant="body1" sx={{ marginBottom: 3, fontStyle: 'italic', color: 'gray' }}>
          {selectedCourseDesc}
        </Typography>
      )}

      <Typography variant="h4" sx={{ marginBottom: 2 }}>
        📚 Course Subjects
      </Typography>

      {subjects.length === 0 ? (
        <Typography variant="h6">No subjects available.</Typography>
      ) : (
      <Box>
        {subjects.map((subject) => (
          <Box key={subject._id} sx={{ mb: 2, border: '1px solid #ccc', borderRadius: 2, boxShadow: 1 }}>
            <Box
              className="flex justify-between items-center bg-white px-4 py-2"
            >
              {/* Only subject name has pointer */}
              <span
                className="flex items-center gap-2 font-semibold text-blue-800 hover:bg-amber-400 cursor-pointer"
                onClick={() => handleExpandClick(subject._id)}
              >
                📘 {subject.semisterNo} - {subject.subjectName}
              </span>

              {/* Only module button clickable */}
              {subjectIdsWithModules.has(String(subject._id)) && (
                <Button
                  variant="outlined"
                  size="small"
                  className="relative cursor-pointer"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(`/elearning/${subject._id}`);
                  }}
                >
                  🎓 eLearning Module
                  <span className="absolute -top-2 -right-2 bg-red-400 text-white text-xs font-bold rounded-full px-1 animate-pulse">
                    ✨ New
                  </span>
                </Button>
              )}
            </Box>




            <Collapse in={expanded === subject._id}>
            <Box sx={{ px: 1, py: 2 }}>
              {loadingBooks[subject._id] ? (
                <Typography>Loading books...</Typography>
              ) : books[subject._id] && books[subject._id].length > 0 ? (
                books[subject._id].map((book) => {
                  const isMapped = userCollegeId && mappedBookIds.has(String(book._id));
                  const isUnmapped = !userCollegeId && !mappedBookIds.has(String(book._id));
                  const hasChapters = bookIdsWithChapters.has(book._id);

                  return (
                    <Card key={book._id} sx={{ mb: 2, display: 'flex', flexDirection: { xs: 'column', md: 'row' }, boxShadow: 3 }}>
                      <CardMedia
                        component="img"
                        sx={{ width: { xs: '100%', md: 200 }, height: { xs: '100%', md: 'auto' }, objectFit: 'cover' }}
                        image={book.coverImageURL}
                        alt={book.bookTitle}
                      />
                      <CardContent>
                        <Typography variant="h6">{book.bookTitle}</Typography>
                        <Typography variant="body2">{book.authorName}</Typography>
                        <Typography variant="body2">{book.bookDescription}</Typography>

                        {(() => {
                          if (isMapped || isUnmapped) {
                            if (hasChapters) {
                              return (
                                <Button variant="outlined" onClick={() => navigate(`/book/${book._id}`)}>
                                  📚 View Book
                                </Button>
                              );
                            } else {
                              return (
                                <Button variant="contained" onClick={() => handleReadBook(book)}>
                                  📘 Read Book
                                </Button>
                              );
                            }
                          } else {
                            return (
                              <Typography variant="body2" sx={{ mt: 1, color: 'orange', fontStyle: 'italic' }}>
                                Not available.
                                <Button
                                  size="small"
                                  variant="text"
                                  onClick={() => {
                                    setSelectedBook(book);
                                    setOpenRecommendModal(true);
                                  }}
                                >
                                  📩 Recommend to your College
                                </Button>
                              </Typography>
                            );
                          }
                        })()}
                      </CardContent>
                    </Card>
                  );
                })
              ) : (
                <Typography>No books available.</Typography>
              )}

              {/* Flipbook Modal for PDF */}
              {pdfUrl && (
                <Dialog
                  open={Boolean(pdfUrl)}
                  onClose={() => setPdfUrl(null)}
                  maxWidth="lg"
                  fullWidth
                >

                </Dialog>
              )}

              {/* Recommendation Dialog */}
              <Dialog open={openRecommendModal} onClose={() => setOpenRecommendModal(false)}>
                <DialogTitle>📩 Recommend eBrary.guru</DialogTitle>
                <DialogContent>
                  <Typography variant="body2" sx={{ mb: 2 }}>
                    Please enter your college email to recommend eBrary.guru to your librarian.
                  </Typography>
                  <TextField
                    label="College Email ID"
                    type="email"
                    fullWidth
                    value={collegeEmail}
                    onChange={(e) => setCollegeEmail(e.target.value)}
                  />
                  {submitStatus && (
                    <Typography variant="caption" color="green" sx={{ mt: 1 }}>
                      {submitStatus}
                    </Typography>
                  )}
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => setOpenRecommendModal(false)}>Cancel</Button>
                  <Button variant="contained" onClick={handleRecommendSubmit}>Send</Button>
                </DialogActions>
              </Dialog>
            </Box>

            </Collapse>
          </Box>
        ))}
      </Box>

      )}
    </Box>
  );

};

export default EbrarySubjects;
